/**
 * IMA-517: přehled Dluhopisy.
 *  - bez clientId: přihlášený klient (api/client-report/bonds/*, fáze 6),
 *  - s clientId: konkrétní klient na jeho detailu pro poradce a administraci (api/clients/{id}/bonds/*, fáze 7;
 *    klient mimo strukturu poradce vrací 404).
 * Menu Dluhopisy poradce používá api/advisor/bonds (fáze 7). Odpovědi mají tvar {status, data}.
 */
function get(url) {
    return new Promise((resolve, reject) => {
        http.get(url).then(response => {
            resolve(response.data.data);
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * POST s odpovědí {status, data}. Při chybě se předá celá odpověď (status + data s kódem chyby nákupu),
 * aby průvodce nákupem mohl reagovat podle `code` (NOT_ENOUGH_PIECES, DOCUMENTS_CHANGED…).
 */
function post(url, payload) {
    return new Promise((resolve, reject) => {
        http.post(url, payload).then(response => {
            resolve(response.data.data);
        }).catch(error => {
            reject(error.response ?? {status: 0, data: {}});
        });
    });
}

/** Adresa přehledu – přihlášený klient, nebo zadaný klient. */
function reportUrl(path, clientId = null) {
    return clientId ? `api/clients/${clientId}/bonds/${path}` : `api/client-report/bonds/${path}`;
}

export default {
    /** Souhrn pro dlaždice + has_bonds / has_available pro přepínač Investice × Dluhopisy. */
    getStats(clientId = null) {
        return get(reportUrl('stats', clientId));
    },
    /** Rozložení podle dluhopisů ve tvaru pro PieChart.vue. */
    getComposition(clientId = null) {
        return get(reportUrl('composition', clientId));
    },
    /** Vlastněné dluhopisy sečtené po dluhopisech. */
    getPositions(clientId = null) {
        return get(reportUrl('positions', clientId));
    },
    /** Pokyny (nákupy) se stavem. */
    getOrders(clientId = null) {
        return get(reportUrl('orders', clientId));
    },
    getUpcomingCoupons(clientId = null) {
        return get(reportUrl('coupons/upcoming', clientId));
    },
    getPaidCoupons(clientId = null) {
        return get(reportUrl('coupons/paid', clientId));
    },
    getCashTransactions(clientId = null) {
        return get(reportUrl('cash-transactions', clientId));
    },
    getSecTransactions(clientId = null) {
        return get(reportUrl('sec-transactions', clientId));
    },
    /** Menu Dluhopisy klienta: {bonds: [...], needs_framework_contract}. */
    getAvailable() {
        return get('api/client-report/bonds/available');
    },
    /** Detail dluhopisu pro klienta; 404, když ho klient nemá a není mu dostupný. */
    getBond(id) {
        return get('api/client-report/bonds/' + id);
    },
    /** Menu Dluhopisy poradce: dluhopisy, které může nabízet, s počtem jeho klientů. */
    getAdvisorBonds() {
        return get('api/advisor/bonds');
    },
    /** Detail nabízeného dluhopisu pro poradce; 404, když ho poradce nabízet nemůže. */
    getAdvisorBond(id) {
        return get('api/advisor/bonds/' + id);
    },
    // IMA-517 fáze 10: nákup dluhopisu klientem (BondPurchaseController)
    /** Krok 1: {calculation, limits, documents, framework_contract_state}. */
    calculatePurchase(bondId, quantity) {
        return post(`api/client-report/bonds/${bondId}/purchase/calculate`, {quantity});
    },
    /** Krok 2: připraví pokyn a rámcovou smlouvu k podpisu – {calculation, purchase_order_document_id, documents_to_sign, …}. */
    preparePurchase(bondId, quantity) {
        return post(`api/client-report/bonds/${bondId}/purchase/prepare`, {quantity});
    },
    /** Krok 3: podpis SMS kódem – {client_bond, payment}. */
    signPurchase(bondId, payload) {
        return post(`api/client-report/bonds/${bondId}/purchase/sign`, payload);
    },
    /** Stav dokumentu k podpisu (is_generating, file) – dokument je do podpisu klientovi skrytý. */
    getPurchaseDocument(bondId, documentId) {
        return get(`api/client-report/bonds/${bondId}/purchase/documents/${documentId}`);
    },
    /** Platební údaje nákupu z aplikace (QR, účet, VS, částka). */
    getPaymentInfo(clientBondId) {
        return get(`api/client-report/bonds/orders/${clientBondId}/payment`);
    },
};
